import { render, staticRenderFns } from "./CustomerData.vue?vue&type=template&id=7b8dca3c&scoped=true&"
import script from "./CustomerData.vue?vue&type=script&lang=js&"
export * from "./CustomerData.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./CustomerData.vue?vue&type=style&index=1&id=7b8dca3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8dca3c",
  null
  
)

export default component.exports